import React from "react";
import { Container, Shape } from "./Styled";
import PageHeader from "../../pageHeader/PageHeader";
import { changeSelectedBotAction } from "../../../business/actions/botActions";

type HomeLayoutProps = {
    title?: string,
    subTitle?: string,
    onBackDestination?: string,
    children: React.ReactNode
};

export const HomeLayout: React.FunctionComponent<HomeLayoutProps> = ({ title, subTitle, onBackDestination, children }) => {
    return (
        <div style={{display: 'flex', overflowY: 'scroll', height:'100%', flexDirection:'column' }}>
        <PageHeader
                onBotSelect={changeSelectedBotAction.request}
                onBackDestination={onBackDestination}
                title={title}
                subTitle={subTitle}
        />
        <Container>
            <Shape />
            {children}
        </Container>
        </div>
    );
};

export default HomeLayout;
